import { render, staticRenderFns } from "./IndagineEpidemiologicaReportsiList.vue?vue&type=template&id=dd2ea5d2"
import script from "./IndagineEpidemiologicaReportsiList.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaReportsiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports